// @flow

export const GetDataFiles = "GET_DATA_FILES";
export const GetDataFilesSuccess = "GET_DATA_FILES_SUCCESS";
export const GetDataFilesError = "GET_DATA_FILES_ERROR";

export const GetValidatingStatus = "GET_VALIDATING_STATUS";
export const GetValidatingStatusSuccess = "GET_VALIDATING_STATUS_SUCCESS";

export const GetDataFileArchive = "DATA_FILE_ARCHIVE_REQUEST";
export const GetDataFileArchiveSuccess = "DATA_FILE_ARCHIVE_SUCCESS";
export const GetDataFileArchiveError = "DATA_FILE_ARCHIVE_ERROR";
export const SetDataFileStatus = "SET_DATA_FILE_STATUS";

export const GetDataFileArchiveSummary = "DATA_FILE_ARCHIVE_SUMMARY_REQUEST";
export const GetDataFileArchiveSummarySuccess = "DATA_FILE_ARCHIVE_SUMMARY_SUCCESS";
export const GetDataFileArchiveSummaryError = "DATA_FILE_ARCHIVE_SUMMARY_ERROR";

export const GetFileChangesDetails = "GET_FILE_CHANGES_DETAILS";
export const GetFileChangesDetailsSuccess = "GET_FILE_CHANGES_DETAILS_SUCCESS";
export const GetFileChangesDetailsError = "GET_FILE_CHANGES_DETAILS_ERROR";

export const OpenFileChangesSummaryModal = "OPEN_FILE_CHANGES_SUMMARY_MODAL";
export const CloseFileChangesSummaryModal = "CLOSE_FILE_CHANGES_SUMMARY_MODAL";

export const OpenFileChangesDetailsModal = "OPEN_FILE_CHANGES_DETAILS_MODAL";
export const CloseFileChangesDetailsModal = "CLOSE_FILE_CHANGES_DETAILS_MODAL";

export const ToggleLoadDataModal = "TOGGLE_LOAD_DATA_MODAL";

export const CreateDataFile = "CREATE_DATA_FILE";
export const CreateDataFileSuccess = "CREATE_DATA_FILE_SUCCESS";
export const CreateDataFileError = "CREATE_DATA_FILE_ERROR";

export const ExportDataFile = "EXPORT_DATA_FILE";
export const ExportDataFileSuccess = "EXPORT_DATA_FILE_SUCCESS";
export const ExportDataFileError = "EXPORT_DATA_FILE_ERROR";

export const GetActiveHierarchy = "GET_ACTIVE_HIERARCHY";
export const GetActiveHierarchySuccess = "GET_ACTIVE_HIERARCHY_SUCCESS";
export const GetActiveHierarchyError = "GET_ACTIVE_HIERARCHY_ERROR";

export const GetExportHistory = "GET_EXPORT_HISTORY";
export const GetExportHistorySuccess = "GET_EXPORT_HISTORY_SUCCESS";
export const GetExportHistoryError = "GET_EXPORT_HISTORY_ERROR";

export const CancelProcessing = "CANCEL_PROCESSING";
export const CancelProcessingSuccess = "CANCEL_PROCESSING_SUCCESS";
export const CancelProcessingError = "CANCEL_PROCESSING_ERROR";

export const ExportFileLogHistory = "EXPORT_HISTORY";
export const ExportFileLogHistorySuccess = "EXPORT_HISTORY_SUCCESS";
export const ExportFileLogHistoryError = "EXPORT_HISTORY_ERROR";

export const GetTransferHistory = "GET_TRANSFER_HISTORY";
export const GetTransferHistorySuccess = "GET_TRANSFER_HISTORY_SUCCESS";
export const GetTransferHistoryError = "GET_TRANSFER_HISTORY_ERROR";
export const DeleteTransferHistoryFile = "DELETE_TRANSFER_HISTORY_FILE";
export const DeleteTransferHistoryFileSuccess = "DELETE_TRANSFER_HISTORY_FILE_SUCCESS";
export const DeleteTransferHistoryFileError = "DELETE_TRANSFER_HISTORY_FILE_ERROR";

export const PostDataTransferFile = "POST_DATA_TRANSFER_FILE";
export const PostDataTransferFileSuccess = "POST_DATA_TRANSFER_FILE_SUCCESS";
export const PostDataTransferFileError = "POST_DATA_TRANSFER_FILE_ERROR";

export const ExportTransferFileHistory = "EXPORT_TRANSFER_FILE_HISTORY";
export const ExportTransferFileHistorySuccess = "EXPORT_TRANSFER_FILE_HISTORY_SUCCESS";
export const ExportTransferFileHistoryError = "EXPORT_TRANSFER_FILE_HISTORY_ERROR";

export const DownloadTransferHistoryFile = "DOWNLOAD_TRANSFER_HISTORY_FILE";
export const DownloadTransferHistoryFileSuccess = "DOWNLOAD_TRANSFER_HISTORY_FILE_SUCCESS";
export const DownloadTransferHistoryFileError = "DOWNLOAD_TRANSFER_HISTORY_FILE_ERROR";

export const ToggleResumeDataModal = "TOGGLE_RESUME_DATA_MODAL";

export const GetDataExceptionTypes = "GET_DATA_EXCEPTION_TYPES";
export const GetDataExceptionTypesSuccess = "GET_DATA_EXCEPTION_TYPES_SUCCESS";
export const GetDataExceptionTypesError = "GET_DATA_EXCEPTION_TYPES_ERROR";

export const GetDataExceptionsByType = "GET_DATA_EXCEPTIONS_BY_TYPE";
export const GetDataExceptionsByTypeSuccess = "GET_DATA_EXCEPTIONS_BY_TYPE_SUCCESS";
export const GetDataExceptionsByTypeError = "GET_DATA_EXCEPTIONS_BY_TYPE_ERROR";

export const SetDataExceptionTypeConfirm = "SET_DATA_EXCEPTION_TYPE_CONFIRM";
export const SetDataExceptionTypeConfirmSuccess = "SET_DATA_EXCEPTION_TYPE_CONFIRM_SUCCESS";
export const SetDataExceptionTypeConfirmError = "SET_DATA_EXCEPTION_TYPE_CONFIRM_ERROR";

export const DeleteDataFile = "DELETE_DATA_FILE";
export const DeleteDataFileSuccess = "DELETE_DATA_FILE_SUCCESS";
export const DeleteDataFileError = "DELETE_DATA_FILE_ERROR";

export const ApproveDataExceptions = "APPROVE_DATA_EXCEPTIONS";
export const ApproveDataExceptionsSuccess = "APPROVE_DATA_EXCEPTIONS_SUCCESS";
export const ApproveDataExceptionsError = "APPROVE_DATA_EXCEPTIONS_ERROR";

export const ToggleReviewDataChangesModal = "TOGGLE_REVIEW_DATA_CHANGES_MODAL";

export const ReviewDataChanges = "REVIEW_DATA_CHANGES";
export const ReviewDataChangesSuccess = "REVIEW_DATA_CHANGES_SUCCESS";
export const ReviewDataChangesError = "REVIEW_DATA_CHANGES_ERROR";
export const GetReviewDataChanges = "GET_REVIEW_DATA_CHANGES";
export const GetReviewDataChangesSuccess = "GET_REVIEW_DATA_CHANGES_SUCCESS";
export const GetReviewDataChangesError = "GET_REVIEW_DATA_CHANGES_ERROR";
export const ResetReviewData = "RESET_REVIEW_DATA";

export const UpdateDraftExceptions = "UPDATE_DRAFT_EXCEPTIONS";

export const OpenUnsavedChangesModal = "OPEN_UNSAVED_CHANGES_MODAL";
export const CloseUnsavedChangesModal = "CLOSE_UNSAVED_CHANGES_MODAL";
export const DiscardUnsavedChanges = "DISCARD_UNSAVED_CHANGES";

export const GetDataDashboardOverview = "GET_DATA_DASHBOARD_OVERVIEW";
export const GetDataDashboardOverviewSuccess = "GET_DATA_DASHBOARD_OVERVIEW_SUCCESS";
export const GetDataDashboardOverviewError = "GET_DATA_DASHBOARD_OVERVIEW_ERROR";

export const ExportDataQualityIssues = "EXPORT_DATA_QUALITY_ISSUES";
export const ExportDataQualityIssuesSuccess = "EXPORT_DATA_QUALITY_ISSUES_SUCCESS";
export const GetDataQualityIssues = "GET_DATA_QUALITY_ISSUES";
export const GetDataQualityIssuesSuccess = "GET_DATA_QUALITY_ISSUES_SUCCESS";
export const GetDataQualityIssuesError = "GET_DATA_QUALITY_ISSUES_ERROR";

export const DownloadDataSipFile = "DOWNLOAD_DATA_SIP_FILE";
export const DownloadDataSipFileSuccess = "DOWNLOAD_DATA_SIP_FILE_SUCCESS";
export const DownloadDataSipFileError = "DOWNLOAD_DATA_SIP_FILE_ERROR";

export const ExportSipFileExceptions = "EXPORT_SIP_FILE_EXCEPTIONS";
export const ExportSipFileExceptionsSuccess = "EXPORT_SIP_FILE_EXCEPTIONS_SUCCESS";
export const ExportSipFileExceptionsError = "EXPORT_SIP_FILE_EXCEPTIONS_ERROR";

export const DownloadSipFileChangesDetails = "DOWNLOAD_SIP_FILE_CHANGES_DETAILS";
export const DownloadSipFileChangesDetailsSuccess = "DOWNLOAD_SIP_FILE_CHANGES_DETAILS_SUCCESS";
export const DownloadSipFileChangesDetailsError = "DOWNLOAD_SIP_FILE_CHANGES_DETAILS_ERROR";
